"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeToken = void 0;
var errors_1 = require("@fleek-platform/errors");
var jose_1 = require("jose");
var decodeToken = function (_a) {
    var token = _a.token;
    try {
        return (0, jose_1.decodeJwt)(token);
    }
    catch (_b) {
        throw new errors_1.AuthorizationError();
    }
};
exports.decodeToken = decodeToken;
